import React from 'react';
import { Switch } from 'antd';
import type { SwitchProps as AntdSwitchProps, SwitchSemanticAllType } from 'antd/es/switch';
import classnames from 'classnames';
import { useThemeVarsClass } from '../../../theme/provider';

import cn from './styles.module.scss';

export type ToggleClassNames = SwitchSemanticAllType['classNames'] & {
  wrapper?: string;
  label?: string;
};

export type ToggleProps = Omit<AntdSwitchProps, 'classNames' | 'onChange' | 'className'> & {
  checked: boolean,
  onChange: (event: React.MouseEvent<HTMLDivElement>, checked: boolean) => void,
  classNames?: ToggleClassNames,
  children?: React.ReactNode,
  'data-testid'?: string
};

export function Toggle({
  checked,
  onChange,
  disabled,
  loading,
  size = 'small',
  classNames: classNamesProp,
  children,
  ...props
}: ToggleProps) {
  const themeClassName = useThemeVarsClass();
  const { wrapper, label, ...switchClassNames } = classNamesProp ?? {};

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!disabled && !loading) {
      onChange(event, !checked);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={classnames(themeClassName, wrapper)}
    >
      <Switch
        size={size}
        checked={checked}
        disabled={disabled}
        loading={loading}
        classNames={switchClassNames}
        {...props}
      />
      <span
        className={classnames(
          cn.label,
          label,
          {
            [cn.disabled]: disabled,
            [cn.sizeDefault]: size !== 'small',
          },
        )}
      >
        {children}
      </span>
    </div>
  );
}
